import { useState, useEffect, useCallback } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

const B = process.env.REACT_APP_BACKEND_URL;

const Shot = ({ id }) => {
  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false);
  const load = async () => { try { const r = await api.get(`/api/admin/zelle/notices/${id}/screenshot`, { responseType: "blob" }); setUrl(URL.createObjectURL(r.data)); setOpen(true); } catch { toast.error("Couldn't load the screenshot"); } };
  return (<><button onClick={url ? () => setOpen(true) : load} className="text-xs text-violet-700 font-semibold underline" data-testid={`zn-shot-${id}`}>View screenshot</button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent className="bg-white max-w-2xl"><img src={url} alt="Zelle receipt" className="w-full max-h-[75vh] object-contain" /></DialogContent></Dialog></>);
};

export const ZelleNoticesCard = () => {
  const [list, setList] = useState(null);
  const [amt, setAmt] = useState({});
  const load = useCallback(() => api.get("/api/admin/zelle/notices").then(r => setList(r.data)).catch(() => setList([])), []);
  useEffect(() => { load(); }, [load]);
  const act = async (n, action) => {
    try { const { data } = await api.post(`/api/admin/zelle/notices/${n.id}`, { action, ...(action === "confirm" && amt[n.id] ? { amount: Number(amt[n.id]) } : {}) }); toast.success(data.message); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!list) return <Loader2 className="w-5 h-5 animate-spin text-violet-600" />;
  if (!list.length) return null;
  return (
    <div className="bg-white border-2 border-violet-200 rounded-xl p-5 shadow-sm mb-6" data-testid="zelle-notices-card">
      <p className="font-bold text-violet-700 mb-3">{list.length} Zelle payment{list.length > 1 ? "s" : ""} to confirm <span className="text-xs font-normal text-slate-500">— check your bank first</span></p>
      <div className="divide-y">{list.map(n => (
        <div key={n.id} className="py-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`zn-${n.id}`}>
          <div className="flex-1 min-w-[220px]"><p className="font-semibold text-slate-900">{n.business_name || n.name} <span className="font-normal text-slate-500">· {n.email}</span></p>
            <p className="text-xs text-slate-500">{new Date(n.created_at).toLocaleString()} · memo {n.memo || "—"}{n.note ? ` · “${n.note}”` : ""}{n.user_id ? "" : " · no matching customer account"}</p>
            {n.screenshot_path && <Shot id={n.id} />}</div>
          <Input type="number" step="0.01" className="w-28 h-9" placeholder={n.amount.toFixed(2)} value={amt[n.id] || ""} onChange={e => setAmt({ ...amt, [n.id]: e.target.value })} data-testid={`zn-amount-${n.id}`} />
          <button onClick={() => act(n, "confirm")} className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded-lg font-semibold" data-testid={`zn-confirm-${n.id}`}>Confirm received</button>
          <button onClick={() => act(n, "dismiss")} className="text-slate-500 hover:text-red-600 px-2" data-testid={`zn-dismiss-${n.id}`}>Dismiss</button>
        </div>))}</div>
      <p className="text-[11px] text-slate-400 mt-2">Confirming adds the payment to the customer's statement and emails them a receipt. Public pay link: <a href="/pay-zelle" className="underline">{B ? "/pay-zelle" : ""}</a></p>
    </div>
  );
};
